import util from './';

export default function getNumericValue(n) {
  if (!n && 0 !== n) {
    return false;
  } else if (util.isNumber(n)) {
    return parseFloat(n);
  }

  const pattern = /,|%|\$|<|>/g;
  const num = parseFloat(n.toString().replace(pattern, ''));
  if (isFinite(num) && !n.toString().match(/[a-zA-Z]/g)) {
    return num;
  }
  return null;
}



// WEBPACK FOOTER //
// ./app/utils/numeric/getNumericValue.js